import React from "react";
import { Link, NavLink } from 'react-router-dom';
import Greetings from './Commons/Greetings';

const HeaderTop = (props) => {
    const { session, handleMenu } = props;

    return  (
        <header className="header-top">
            <div className="logo-wrap">
                <Link className="logo" to="/">
                    <img src="/static/images/logo.svg" alt=""/>
                </Link>
            </div>
            <div onClick={() => handleMenu()} className="user-menu-icon"></div>
            <div className="header-right">
                <div className="user-greeting-sprite">

                    {
                        (!session.isFetching && session.isLoggedIn)
                            ?
                            <Greetings
                                user={session.currentUser}
                            />
                            :
                            <span className="login-block">
                            <NavLink to="/signin" className="signin-link" onClick = {() => handleMenu()}>Авторизация</NavLink>
                            <NavLink to="/signup" className="signup-link" onClick = {() => handleMenu()}>Регистрация</NavLink>
                        </span>
                    }
                </div>
                <nav className="main-nav">
                    <NavLink className="main-nav__link" exact to="/" onClick = {() => handleMenu()}><span>Главная</span></NavLink>
                    {
                        session.isLoggedIn ?
                        <NavLink className="main-nav__link" to="/profile" onClick = {() => handleMenu()}><span>Профиль</span></NavLink>
                        : null
                    }
                    {
                        session.isLoggedIn ?
                        <NavLink className="main-nav__link" to="/orders" onClick = {() => handleMenu()}><span>Заказы</span></NavLink>
                        : null
                    }
                    
                    <NavLink className="main-nav__link" to="/buy" onClick = {() => handleMenu()}><span>Публикации</span></NavLink>
                    <NavLink className="main-nav__link" to="/news" onClick = {() => handleMenu()}><span>Новости</span></NavLink>
                    <NavLink className="main-nav__link" to="/information" onClick = {() => handleMenu()}><span>Информация</span></NavLink>
                </nav>
            </div>
        </header>
    )
}

export default HeaderTop


// WEBPACK FOOTER //
// ./src/components/HeaderTop.js